import {
  bridge,
  os,
  native,
} from '@ali/amap-lib';

export default {
  isImmersion() {
    return new Promise((resolve) => {
      if (os.android) {
        native.compareDiv('090000', (res) => {
          if (res) {
            const obj = {
              action: 'getImmersiveStatusBarHeight',
            };
            bridge.send(obj, (info) => {
              if (info && info.height) {
                const height = info.height / window.devicePixelRatio;
                console.log('getImmersiveStatusBarHeight', info);
                resolve(height);
              } else {
                resolve(false);
              }
            });
          } else {
            resolve(false);
          }
        });
      } else {
        // 1070 ios支持获取顶部高度
        native.compareDiv('100700', (res) => {
          if (res) {
            const obj = {
              action: 'screenSafeArea',
            };
            bridge.send(obj, (info) => {
              if (info && info.top) {
                const height = info.top * window.innerWidth / 750;
                console.log('screenSafeArea', info);
                resolve(height);
              } else {
                resolve(false);
              }
            });
          } else {
            resolve(false);
          }
        });
      }
    });
  },
};